import React from 'react';

const SpeedingEuroIcon = ({ fill = '#32C24D', width = 20, height = 16, ...rest }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 20 16" {...rest}>
            <path
                fill={fill}
                fillRule="evenodd"
                d="M4.176 9.678a.5.5 0 0 1 .978-.209A7 7 0 1 0 12 1H.5a.5.5 0 1 1 0-1H12a8 8 0 1 1-7.824 9.678zm8.64-.4h-2.004c.02.59.176 1.033.47 1.33.292.298.748.446 1.366.446.419 0 .798-.062 1.137-.187L14 12.325a6.658 6.658 0 0 1-1.531.175c-1.05 0-1.88-.284-2.492-.852-.612-.569-.934-1.359-.966-2.37H8V8.36h1.011v-.747H8V6.7h1.023c.068-1.012.418-1.798 1.05-2.359.632-.56 1.47-.84 2.515-.84.419 0 .89.062 1.412.187l-.215 1.464a3.399 3.399 0 0 0-1.107-.193c-1.129 0-1.747.58-1.854 1.74h1.992v.916h-2.004v.747h2.004v.916zM.5 3h6a.5.5 0 1 1 0 1h-6a.5.5 0 1 1 0-1zm0 3h4a.5.5 0 1 1 0 1h-4a.5.5 0 1 1 0-1z"
            />
        </svg>
    );
};

export default SpeedingEuroIcon;
